class MegaMenu extends HTMLElement {
  static CONSTANTS = {
    CLASSES: {
      OPEN: "desktop-menu-open",
      CLOSING: "desktop-menu-closing",
      ACTIVE: "active",
    },
    DURATIONS: {
      TRANSITION: 300,
      LEAVE_DELAY: 100,
      OPEN_DELAY: 20,
    },
  };

  constructor() {
    super();
    this.timer = null;
    this.closeTimer = null;
    this.leaveTimer = null;
    this.items = this.querySelectorAll(":scope > .header-menu.mega");
    this.toggles = this.querySelectorAll(":scope > .header-menu.mega > summary");
    this.menus = this.querySelectorAll(".header-menu-content");
    this.onBodyClickEvent = this.onBodyClick.bind(this);
    this.init();
  }

  init() {
    const isClickTrigger = this.dataset.trigger === "click";
    
    this.toggles.forEach((toggle) => {
      if (isClickTrigger) {
        toggle.setAttribute("role", "button");
        toggle.addEventListener("click", this.handleTriggerClick.bind(this));
      } else {
        toggle.addEventListener("click", this.handleTriggerClickWithBlock.bind(this));
        toggle.addEventListener("mouseenter", this.openMenu.bind(this));
      }
    });

    if (!isClickTrigger) {
      // 1) Bind hover bounds to the parent `<details>` wrapping both content and toggle, 
      // ensuring proper hit box capture to prevent the "blocked hanging" bug.
      this.items.forEach((item) => {
        item.addEventListener("mouseleave", this.handleMenuMouseLeave.bind(this));
        item.addEventListener("mouseenter", this.handleMenuMouseEnter.bind(this));
      });
      
      this.menus.forEach((menu) => {
        const overlay = menu.querySelector(".modal-overlay");
        if (overlay) {
          overlay.addEventListener("mouseenter", this.handleMenuMouseLeave.bind(this));
        }
      });
    }
  }

  openMenu(event) {
    this.clearAllTimers();
    this.detailsContainer = event.target.closest("details");
    if (!this.detailsContainer) return;
    
    this.detailsContainer.setAttribute("open", true);
    document.body.classList.add(MegaMenu.CONSTANTS.CLASSES.OPEN);
    document.body.classList.remove(MegaMenu.CONSTANTS.CLASSES.CLOSING);
    
    setTimeout(() => {
      if(this.detailsContainer){
        this.detailsContainer.classList.add(MegaMenu.CONSTANTS.CLASSES.ACTIVE);
      }
    }, MegaMenu.CONSTANTS.DURATIONS.OPEN_DELAY);

    this.items.forEach((item) => {
      if (
        item !== this.detailsContainer &&
        (item.classList.contains(MegaMenu.CONSTANTS.CLASSES.ACTIVE) || item.hasAttribute("open"))
      ) {
        item.classList.remove(MegaMenu.CONSTANTS.CLASSES.ACTIVE);
        // 2) Remove the 10ms race condition timeout and clear state synchronously
        // protecting rapidly switched siblings from hidden active blocks.
        item.removeAttribute("open");
      }
    });
    
    document.body.addEventListener("click", this.onBodyClickEvent);
  }

  closeMenu(trapFocus = true) {
    if (!this.detailsContainer) return;
    if (trapFocus && typeof removeTrapFocus === "function") {
      removeTrapFocus(this.summaryToggle);
    }
    
    this.detailsContainer.classList.remove(MegaMenu.CONSTANTS.CLASSES.ACTIVE);
    document.body.classList.add(MegaMenu.CONSTANTS.CLASSES.CLOSING);
    
    this.closeTimer = setTimeout(() => {
      if(this.detailsContainer) {
        this.detailsContainer.removeAttribute("open");
      }
      document.body.classList.remove(MegaMenu.CONSTANTS.CLASSES.OPEN);
      document.body.classList.remove(MegaMenu.CONSTANTS.CLASSES.CLOSING);
    }, MegaMenu.CONSTANTS.DURATIONS.TRANSITION);
    
    document.body.removeEventListener("click", this.onBodyClickEvent);
  }

  handleMenuMouseLeave(event) {
    this.clearAllTimers();
    this.leaveTimer = setTimeout(() => {
      this.menuProcessClose(event);
    }, MegaMenu.CONSTANTS.DURATIONS.LEAVE_DELAY);
  }

  menuProcessClose(event) {
    this.clearAllTimers();
    this.detailsContainer = event.target.closest("details");
    if (!this.detailsContainer) return;
    
    document.body.classList.remove(MegaMenu.CONSTANTS.CLASSES.OPEN);
    document.body.classList.add(MegaMenu.CONSTANTS.CLASSES.CLOSING);
    
    this.items.forEach((item) => {
      item.classList.remove(MegaMenu.CONSTANTS.CLASSES.ACTIVE);
    });
    
    this.closeTimer = setTimeout(() => {
      this.items.forEach((item) => {
        item.removeAttribute("open");
      });
      document.body.classList.remove(MegaMenu.CONSTANTS.CLASSES.CLOSING);
    }, MegaMenu.CONSTANTS.DURATIONS.TRANSITION);
  }

  handleMenuMouseEnter() {
    this.clearAllTimers();
    document.body.classList.remove(MegaMenu.CONSTANTS.CLASSES.CLOSING);
  }

  clearAllTimers() {
    if (this.timer) clearTimeout(this.timer);
    if (this.closeTimer) clearTimeout(this.closeTimer);
    if (this.leaveTimer) clearTimeout(this.leaveTimer);
  }

  handleTriggerClickWithBlock(event) {
    if (event.target.closest("a")) return;
    event.preventDefault();
    this.detailsContainer = event.target.closest("details");
    if (this.detailsContainer.hasAttribute("open")) {
      this.menuProcessClose(event);
    }
  }

  handleTriggerClick(event) {
    event.preventDefault();
    const details = event.target.closest("details");
    if (details.hasAttribute("open")) {
      this.detailsContainer = details;
      this.closeMenu();
    } else {
      this.openMenu(event);
    }
  }

  onBodyClick(event) {
    const isOutside = !this.contains(event.target) || event.target.classList.contains("modal-overlay");
    if (isOutside) {
      this.closeMenu(false);
    }
  }
}

customElements.define("mega-menu", MegaMenu);
